import React from 'react';
import {
  RadioGroup as DefaultRadioGroup,
  RadioButton as DefaultRadioButton,
  FormControlLabel as DefaultFormControlLabel
} from '@ui-propulsion/react-components';
import { array, string } from 'prop-types';

export const RadioButton = ({ value, label, ...props }) => {
  const radioElement = <DefaultRadioButton {...props} value={value} />;

  return label ? (
    <DefaultFormControlLabel
      control={radioElement}
      value={value}
      label={label}
    />
  ) : (
    radioElement
  );
};

RadioButton.propTypes = {
  value: string,
  label: string
};

export const RadioGroup = ({ listItems, ...props }) => (
  <DefaultRadioGroup {...props}>
    {listItems &&
      listItems.map(({ value, label, ...itemProps }) => (
        <RadioButton key={value} value={value} label={label} {...itemProps} />
      ))}
  </DefaultRadioGroup>
);

RadioGroup.propTypes = {
  listItems: array
};

